// extracted by mini-css-extract-plugin
export var alignTop = "LayoutWrapper-module--alignTop--91375";
export var closeMobile = "LayoutWrapper-module--closeMobile--34593";
export var content = "LayoutWrapper-module--content--fd33c";
export var desc = "LayoutWrapper-module--desc--f47e8";
export var featureBullet = "LayoutWrapper-module--featureBullet--b335f";
export var featureContainer = "LayoutWrapper-module--featureContainer--10d04";
export var featureHeading = "LayoutWrapper-module--featureHeading--b86bf";
export var featureIcon = "LayoutWrapper-module--featureIcon--618ea";
export var featureImage = "LayoutWrapper-module--featureImage--55e41";
export var featureItem = "LayoutWrapper-module--featureItem--d61b9";
export var featureList = "LayoutWrapper-module--featureList--41f2c";
export var featureMemberContainer = "LayoutWrapper-module--featureMemberContainer--56263";
export var featureMemberItem = "LayoutWrapper-module--featureMemberItem--48ceb";
export var featureWrapper = "LayoutWrapper-module--featureWrapper--770ea";
export var icon = "LayoutWrapper-module--icon--df1b5";
export var svgIcon = "LayoutWrapper-module--svgIcon--7cf92";
export var tag = "LayoutWrapper-module--tag--50bf1";
export var title = "LayoutWrapper-module--title--9bcff";
export var widgetLayout = "LayoutWrapper-module--widgetLayout--4a5ff";
export var widgetValue = "LayoutWrapper-module--widgetValue--7a77c";
export var widgetWrapper = "LayoutWrapper-module--widgetWrapper--86164";